// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__3qczA","contained":"OpenButton_contained__2OB1H","disabled":"OpenButton_disabled__1DsLT","error":"OpenButton_error__1mhuw"};